import { Fragment } from "react/jsx-runtime";

export function HowItWorks() {
  const steps = [
    {
      number: "1",
      title: "Connect & Share",
      description:
        "One person registers and invites the other. Each person privately shares their side of the story at their own pace.",
    },
    {
      number: "2",
      title: "Align & Choose",
      description:
        "Dfuse helps you both identify the real problem, then provides solution options for you to choose together.",
    },
    {
      number: "3",
      title: "Reconcile",
      description:
        "You get an actionable plan with practical and personalized steps to implement the resolution strategy and strengthen your relationship.",
    },
  ];

  return (
    <section
      id="how-it-works"
      className="container mx-auto py-8 sm:py-12 md:py-16 lg:py-5xl px-4 sm:px-6 md:px-10 lg:px-xl space-y-6 sm:space-y-8 md:space-y-12 lg:space-y-3xl"
    >
      <div className="space-y-2 sm:space-y-sm flex items-center justify-center flex-col">
        <h2 className="text-greyscale-default font-family-gabarito text-[28px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-bold leading-[32px] sm:leading-[40px] md:leading-[48px] lg:leading-3xl text-center">
          Resolution in 3 Guided Steps
        </h2>
        <p className="font-family-reddit-sans text-greyscale-subtle text-center text-base sm:text-lg md:text-xl leading-[22px] sm:leading-[24px] md:leading-[28px] max-w-[900px] px-4">
          Dfuse provides a safe, neutral space where two people can move past
          conflict and work toward resolution, together, at their own pace.
        </p>
      </div>
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-4">
        {steps.map((step, index) => (
          <Fragment key={index}>
            <div className="flex max-w-[400px] w-full flex-col items-center gap-4 sm:gap-6 md:gap-xl">
              <img
                src={`/images/how-dfuse-works-${step.number}.png`}
                alt={step.title}
                className="w-full max-w-[280px] sm:max-w-[320px] max-h-[250px] sm:max-h-[290px] aspect-320/290 h-full object-contain"
              />
              <div className="flex flex-col items-center gap-1 sm:gap-2xs">
                <h3 className="text-greyscale-default text-center font-family-gabarito text-xl sm:text-2xl md:text-[28px] font-bold leading-[28px] sm:leading-[32px] md:leading-xl">
                  {step.number}. {step.title}
                </h3>
                <p className="text-greyscale-subtle text-center font-family-reddit-sans text-sm sm:text-base md:text-lg leading-[20px] sm:leading-[22px] md:leading-[24px] px-4 md:px-0">
                  {step.description}
                </p>
              </div>
            </div>

            {index < steps.length - 1 && (
              <div className="w-[40px] shrink-0 hidden md:block">
                <img
                  src={"/arrow.svg"}
                  alt="Arrow Right"
                  className={`animate-[bounce-width_2s_cubic-bezier(0.34,1.56,0.64,1)_infinite] ${
                    index % 2 === 0
                      ? "[animation-delay:800ms]"
                      : "[animation-delay:1.8s]"
                  }`}
                />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </section>
  );
}
